"use client"

import { NavigationOff } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `NavigationOffIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const NavigationOffIcon = component(Icon)({ as: NavigationOff })
